export const PRIORITY_PREVIEW_STORAGE_KEY = "monity.priorityPreviewCameraId";

// 민트캠 프리뷰 "표시 설정"에서 고른 카메라 목록.
//
// 쓰는 쪽(PriorityPreviewCard)과 읽는 쪽(LivePreview)이 **서로 다른 키와 다른 이벤트**를
// 각자 파일에 적어두는 바람에, 설정을 바꿔도 프리뷰가 그대로였다(2026-09-23 발견).
// 같은 값을 두 곳에 적으면 반드시 어긋나므로 여기 한 곳에만 둔다.
//
// storage 이벤트는 **다른 탭에서만** 발생한다. 설정을 바꾼 그 탭에서도 반영되려면
// 저장한 쪽이 이 커스텀 이벤트를 직접 쏴야 한다.
export const PRIORITY_PREVIEW_SELECTED_LIST_KEY =
  "monity.priorityPreview.selectedCameraKeys.v1";
export const PRIORITY_PREVIEW_LIST_CHANGED_EVENT =
  "priority-preview-list-changed";
export const DASHBOARD_STATUS_POLL_MS = 5000;
export const DASHBOARD_STATUS_HIDDEN_POLL_MS = 30000;

export function normalizeBatteryValue(value) {
  if (value === null || value === undefined || value === "") return null;

  const num = Number(value);
  if (!Number.isFinite(num)) return null;

  const rounded = Math.round(num);
  if (rounded < 0 || rounded > 100) return null;

  return rounded;
}

export function toMillis(value) {
  if (!value) return 0;

  if (value instanceof Date) {
    const ms = value.getTime();
    return Number.isFinite(ms) ? ms : 0;
  }

  if (typeof value === "number") {
    if (value > 1e12) return value;
    if (value > 1e9) return value * 1000;
    return 0;
  }

  const str = String(value).trim();
  if (!str) return 0;

  const num = Number(str);
  if (Number.isFinite(num)) {
    if (num > 1e12) return num;
    if (num > 1e9) return num * 1000;
  }

  const parsed = Date.parse(str);
  return Number.isFinite(parsed) ? parsed : 0;
}

export function formatDateTimeKst(value) {
  const ms = toMillis(value);
  if (!ms) return "";

  return new Date(ms).toLocaleString("ko-KR", {
    timeZone: "Asia/Seoul",
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    second: "2-digit",
  });
}

export function getLogDisplayTime(log) {
  return (
    formatDateTimeKst(
      log?.timestamp ||
        log?.Timestamp ||
        log?.updatedAt ||
        log?.UpdatedAt ||
        log?.createdAt ||
        log?.CreatedAt ||
        log?.eventAt ||
        log?.EventAt ||
        log?.time ||
        log?.Time ||
        log?.occurredAt ||
        log?.OccurredAt
    ) || ""
  );
}

export function getDashboardDeviceTypeLabel(cam) {
  const sourceType = String(cam?.sourceType || "").trim().toLowerCase();
  const siteName = String(cam?.siteName || "").trim().toLowerCase();
  const sourceRtsp = String(cam?.sourceRtsp || cam?.rtspUrl || "")
    .trim()
    .toLowerCase();
  const name = String(cam?.name || cam?.camName || cam?.camTitle || "")
    .trim()
    .toLowerCase();

  if (
    sourceType.includes("cctv") ||
    sourceType.includes("nvr") ||
    siteName.includes("cctv") ||
    name.includes("cctv")
  ) {
    return "이동형 CCTV";
  }

  if (
    sourceType.includes("mintcam") ||
    sourceType.includes("mint") ||
    name.includes("민트캠") ||
    sourceRtsp.includes("mint")
  ) {
    return "민트캠";
  }

  return sourceType ? sourceType : "민트캠";
}

export function buildDashboardStatusMap(statuses) {
  const nextMap = {};

  for (const item of Array.isArray(statuses) ? statuses : []) {
    const key = String(item?.camIdx ?? item?.camNo ?? "");
    if (!key) continue;

    nextMap[key] = {
      liveStatus: String(item?.liveStatus || "OFFLINE").toUpperCase(),
      battery: normalizeBatteryValue(item?.battery),
      workerName:
        item?.workerName ||
        item?.userName ||
        item?.deviceName ||
        item?.name ||
        "",
      // 작업자 이름과 항상 같이 표시돼야 하는 값들.
      // 여기서 안 담으면 statusMap 을 쓰는 화면(LivePreview 등)에서 통째로 사라진다.
      vehicleNo: item?.ownerVehicleNo || item?.vehicleNo || "",
      teamName: item?.ownerTeamName || item?.teamName || "",
      branchName: item?.ownerBranchName || item?.branchName || "",
    };
  }

  return nextMap;
}

export function buildDashboardStatusText(status) {
  const liveStatus = String(status || "OFFLINE").toUpperCase();

  if (liveStatus === "ONLINE") return "온라인";
  if (liveStatus === "DISABLED") return "비활성";

  return "오프라인";
}